import {request} from "../../request/request";

const scope = {
  getAvailable: (params) => request.read('/oauth/scope/available', params, true),
};

export {scope};